export type SpinnerProps = {
  color?:
    | 'navy'
    | 'red'
    | 'white'
    | 'skyBlue'
    | 'gold'
    | 'lightGrey'
    | 'darkGrey'
  size?: 'sm' | 'md' | 'lg'
  shadow?: boolean
}

export const Spinner: React.FC<SpinnerProps> = ({
  color = 'navy',
  size = 'sm',
  shadow = false,
}) => {
  const spinner = (
    <div
      className={`animate-duration-500 animate-spin rounded-full border-2 border-solid border-t-transparent ${shadow ? 'shadow-md' : ''} ${size === 'sm' && 'h-4 w-4 border-2'} ${size === 'md' && 'h-8 w-8 border-2'} ${size === 'lg' && 'h-10 w-10 border-2'} ${color === 'navy' && 'border-navy'} ${color === 'red' && 'border-red'} ${color === 'white' && 'border-white'} ${color === 'skyBlue' && 'border-sky-blue'} ${color === 'darkGrey' && 'border-grey-60'} ${color === 'lightGrey' && 'border-grey-20'} ${color === 'gold' && 'border-gold'} `}
    ></div>
  )

  return <div className='relative'>{spinner}</div>
}
